export enum PENDING_MEMBERSHIP_STATUS {
  requested = 'requested',
  rejected = 'rejected',
}
